// Legacy Australian settings used "$"; API writes require currency codes.
export function rctiCurrencyCode(savedCurrency, defaultCurrency) {
  const value = [savedCurrency, defaultCurrency].find(
    currency => typeof currency === "string" && currency.trim()
  ) || "AUD";
  const code = value.trim().toUpperCase();
  return ["$", "A$", "AU$"].includes(code) ? "AUD" : code;
}
